import { render, staticRenderFns } from "./SettingChoiceWidget.vue?vue&type=template&id=aade8cda&scoped=true"
import script from "./SettingChoiceWidget.vue?vue&type=script&lang=js"
export * from "./SettingChoiceWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aade8cda",
  null
  
)

export default component.exports